export default {"src":"/_next/static/media/logo-Ask-Cimigo.ea7a152a.svg","height":48,"width":184,"blurWidth":0,"blurHeight":0};